import React from "react";
import { Table, Button, Popover, OverlayTrigger } from "react-bootstrap";
import { Edit, Eye, Trash } from "lucide-react";

const DropdownList = ({ dropdown, onEdit, onDelete, deletingId }) => {
  //   const viewPopover = (
  //     <Popover id="popover-view">
  //       <Popover.Body>View Category details</Popover.Body>
  //     </Popover>
  //   );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit dropdown item</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete dropdown item </Popover.Body>
    </Popover>
  );
  const dropdownFilter = dropdown.sort((a, b) => a.title.localeCompare(b.title))
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Category</th>
          <th>Title</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {dropdownFilter.length > 0 ? (
          dropdownFilter.map((drop, idx) => (
            <tr key={drop.id}>
              <td>{idx + 1}</td>
              <td>{drop.category}</td>
              <td>{drop.title}</td>
              <td>
                {/* <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={viewPopover}
                >
                  <Button
                    size="sm"
                    className="me-1"
                    style={{
                      backgroundColor: "#10296C",
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onView(drop)}
                  >
                    <Eye />
                  </Button>
                </OverlayTrigger> */}
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    size="sm"
                    variant="warning"
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    className="me-1"
                    onClick={() => onEdit(drop)}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    size="sm"
                    variant="danger"
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onDelete(drop.id)}
                    disabled={deletingId === drop.id}
                  >
                    {deletingId === drop.id ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Deleting...
                      </>
                    ) : (
                      <Trash />
                    )}
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              No Dropdown found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default DropdownList;
